import { MissionData } from '../blocks/mission'
import template from './templates/RJS03.rbxl'
import thumbnail1 from './thumbnails/RJS03/Block.png'
import thumbnail2 from './thumbnails/RJS03/SpawnLocation.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②スタートちてん',
      thumbnail: thumbnail2,
    },
  ],
}

export default mission
